import { OrderedSet, Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  CONVERSATIONS_FETCHED,
  NAV_TO_CONVERSATION,
  CONVERSATION_UPDATED,
  PINNED_CHANGE,
  HOIST_CONV,
  MARK_READ_SUCCESS,
  ADD_CONVERSATION,
  REMOVE_CONVERSATION,
  CONV_STATS_FETCHED,
  RESET_CONVS
} from './actionTypes'
import { RECEIVE_MESSAGE } from '../messages/actionTypes'
import { CONV_REFRESH } from '../socket/actionTypes';

const initializeState = Map({
  currentId: null,
  pinned: OrderedSet(),
  unpinned: OrderedSet(),
  entries: Map(),
  displayOrderId: null,
  convRefreshKey: 'initkey'
})

function remove(state, convId) {
  return state
    .update('pinned', list => list.remove(convId))
    .update('unpinned', list => list.remove(convId))
}

function isPinned(state, convId) {
  return state.hasIn(['pinned', convId])
}

function isUnpinned(state, convId) {
  return state.hasIn(['unpinned', convId])
}

function addPinned(state, convId) {
  return state.update('pinned', list => list.add(convId))
}

function addUnpinned(state, convId) {
  return state.update('unpinned', list => list.add(convId))
}

export default createReucer({
  [CONVERSATIONS_FETCHED]: (state, { payload }) => {
    // console.log('payload:', payload)
    // 时间
    const { data, type } = payload
    data.sort((conv1, conv2) => conv2.latest_ts - conv1.latest_ts)

    const pinned = []
    const unpinned = []
    const all = []
    for (const conv of data) {
      (conv.is_pinned ? pinned : unpinned).unshift(conv._id)
    }

    // return

    return state.withMutations(mutable => {
      // if (payload.length) {
      //   mutable.set('currentId', payload[0]._id)
      // }
      mutable
        .set('pinned', OrderedSet(pinned))
        .set('unpinned', OrderedSet(unpinned))
      mutable.set('convs_query_type', type)
      //mutable.set('entries',Map(all))
      data.forEach(item => {
        const { order, ...conv } = item
        mutable.setIn(['entries', item._id], Map(conv))
      })

      // payload.forEach(item => {
      //   const { order, ...conv} = item

      //   console.log('item.order.order_no', item.order.order_no)

      //   mutable.setIn(['entries', item._id], Map({ ...conv }))
      //   mutable.update(
      //     conv.is_pinned ? 'pinned': 'unpinned',
      //     list => list.add(item._id)
      //   )
      // });
    })
  },

  [ADD_CONVERSATION]: (state, { payload }) => {
    return addUnpinned(
      state.setIn(['entries', payload._id], Map(payload)),
      payload._id
    )
  },

  [REMOVE_CONVERSATION]: (state, { payload }) =>
    remove(state, payload.id),

  [NAV_TO_CONVERSATION]: (state, { payload }) => {
    return state.set('currentId', payload.id || null).set('displayOrderId', payload.orderId || null)
  },

  [CONVERSATION_UPDATED]: (state, { payload }) =>
    state.mergeDeepIn(['entries', payload._id], payload),

  [PINNED_CHANGE]: (state, { payload }) => {
    const { id, is_pinned } = payload
    return (is_pinned ? addPinned : addUnpinned)(remove(state, id), id)
  },

  [RECEIVE_MESSAGE]: (state, { payload }) => {
    const conv = state.get('entries').find(item => item.get('order_id') === payload.order_id)
    const isCurrentUser = (!payload.createBy || window.uid !== payload.createBy._id)

    if (!conv) {
      return state
    }
    if (payload.from_type === 'system') {
      return state
    }

    return state
      .updateIn(['entries', conv.get('_id')], item => {
        return item
          .set('latest_ts', payload.createdAt)
          .set('unread_count', item.get('unread_count') + isCurrentUser)
      })
  },

  [HOIST_CONV]: (state, { payload }) => {
    const { id } = payload
    const addHandler = isPinned(state, id) ? addPinned : addUnpinned

    return addHandler(remove(state, id), id)
  },

  [MARK_READ_SUCCESS]: (state, { payload }) => {
    const { id } = payload

    return state.setIn(['entries', id, 'unread_count'], 0)
  },
  [CONV_STATS_FETCHED]: (state, { payload }) => {
    const { type, total } = payload
    return state.setIn(['convs_stats', type], total)
  },
  [RESET_CONVS]: (state, { payload }) => {
    return state.withMutations(mutable => {
      mutable.set('pinned', OrderedSet())
      mutable.set('unpinned', OrderedSet())
      mutable.set('entries', Map())
    })
  },
  [CONV_REFRESH](state, { payload }) {
    return state.set('convRefreshKey', Date.now())
  },
}, initializeState)
